import {useFetcher, useMatches, useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import type {RootLoaderResponse} from '~/types'
import {getTranslation} from '~/localization/translation'
import {getDomainConfig} from '~/domains'

const GotItCookieConsent = ({
  showOnBottom,
  showCookieConsentGdpr,
  setShowCookieConsentGdpr,
}: {
  showOnBottom?: boolean
  showCookieConsentGdpr: boolean
  setShowCookieConsentGdpr: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const {domain, language, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)
  const translations = getTranslation(language)
  const analyticsFetcher = useFetcher()

  const location = useMatches()
  const isErrorPage = Boolean(location.some(({id}) => id === 'routes/404'))

  return (
    showCookieConsentGdpr && (
      <div
        data-testid="cookie-consent"
        className={clsx(
          'z-50 w-full bg-white mobile:h-14',
          isErrorPage ? '' : 'h-[62px]',
          showOnBottom ? 'fixed bottom-0 mobile:h-min' : 'sticky top-16',
        )}
      >
        <div
          className={clsx(
            'flex w-full justify-center border-b-neutral-200 bg-white py-2',
            showOnBottom ? 'border-t desktop:flex desktop:h-full' : 'absolute top-0 border',
          )}
        >
          <div
            className={clsx('utils_main_container flex flex-row justify-between', stylesBydomain.UTILS_MAIN_CONTAINER)}
          >
            <div className="flex flex-col pr-4">
              <span className="text-sm font-bold text-black">{translations.CookieConsent.title}</span>
              <span
                className="text-[10px] leading-3 text-neutral-700 [&>a]:underline"
                dangerouslySetInnerHTML={{__html: translations.CookieConsent.consentText}}
              />
            </div>
            <analyticsFetcher.Form
              method="post"
              action="/cookie-consent"
              className="flex items-center"
              onSubmit={() => {
                setShowCookieConsentGdpr(false)
              }}
            >
              <input type="hidden" name="cookieConsent" value="hidden" />
              <button
                data-testid="accept-button"
                className="my-auto h-9 min-w-max rounded-3xl bg-neutral-700 px-4 text-white"
                name="accept-gdpr"
                value="granted"
                type="submit"
              >
                {translations.CookieConsent.gotItButton}
              </button>
            </analyticsFetcher.Form>
          </div>
        </div>
      </div>
    )
  )
}

export default GotItCookieConsent
